import { ChangeQueueMenuList } from 'app/modules/queues/components/ChangeQueueMenuList';
import { QueueType } from 'app/modules/queues/models';
import { useRequeueAlert } from 'app/modules/alerts/queries/useRequeueAlert';

interface Props {
  id: number;
  onSuccess?: () => void;
}

export const RequeueMenuList = (props: Props) => {
  const { id, onSuccess } = props;

  const { mutateAsync: requeueAlert } = useRequeueAlert([id]);
  return (
    <ChangeQueueMenuList
      key="requeue"
      onChange={async (queueID) => {
        try {
          await requeueAlert(queueID);
          onSuccess?.();
        } catch {}
      }}
      queueType={QueueType.ALERT_QUEUE}
    />
  );
};
